import Validator from "../../utils/Validator";

import { FsdAddressType } from "./FsdAddress";
import { CustomerId } from "./CustomerId";

/**
 * The json as it comes from the customer service + a few utility methods.
 * NOTE: We only parse the data we really need. If you need more attributes, this is the place to parse them.
 */
class Customer {
    customerId: CustomerId;
    displayNumber: string;
    food: boolean | null | undefined;
    deliveryAddresses: Array<FsdAddressType>;
    customerName: string;
    primaryCardholderNumber: string;
    validForFsd: boolean;
    validForWeb: boolean;
    targetGroup: string | null | undefined;
    categoryGroups: Array<string> | null | undefined;
    segment: string | null | undefined;
    tags: Array<string> | null | undefined;

    constructor(json: { [x: string]: any }) {
        this.customerId = Validator.validateString(json, "customerId");
        this.displayNumber = Validator.validateString(json, "displayNumber");
        this.food = Validator.validateOptionalBoolean(json, "food");
        const addresses = Validator.validateOptionalArray(json, "addresses");
        this.deliveryAddresses = addresses
            ? addresses.filter((item: { [x: string]: any }) => {
                  return (item.addressType === "DELIVERY" || item.addressType === "DELIVERY_COD") && item.deliveryStore;
              })
            : [];
        this.customerName = Validator.validateString(json, "customerName1");
        this.primaryCardholderNumber = Validator.validateString(json, "primaryCardholderNumber");
        this.validForFsd = Validator.validateBoolean(json, "validForFsd");
        this.validForWeb = Validator.validateBoolean(json, "validForWeb");
        this.targetGroup = Validator.validateOptionalString(json, "branchCode");
        this.categoryGroups = Validator.validateOptionalArray(json, "categoryGroupCodes");
        this.segment = Validator.validateNullableString(json, "segment");
        this.tags = Validator.validateOptionalArray(json, "tags");
    }
}

export default Customer;
